module.exports = __webpack_public_path__ + "img/Pelletsofen.2f1660c.webp";